const ORIENTATION_TYPES = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};

const BORDER_TYPES = {
  ALL: 'all',
  START: 'start',
  END: 'end',
};

export { ORIENTATION_TYPES, BORDER_TYPES };
